import {
  BarChart3, Briefcase, Circle, ClipboardCheck, ClipboardList, Clock, Cloud, Cog, Compass,
  DollarSign, Eye, EyeOff, Factory, FileCheck, FileText, Gauge, HardHat, HeartHandshake,
  Landmark, Layers,
  ListChecks, Map, Network, RefreshCw, Ruler, Scale, ScanSearch, Search, Server, ShieldCheck,
  ShoppingCart, Sparkles, Stethoscope, Target, Telescope, TrendingUp, UserCog, Users,
  Video, Workflow,
} from "lucide-react";

const ICONS = {
  BarChart3, Briefcase, Circle, ClipboardCheck, ClipboardList, Clock, Cloud, Cog, Compass,
  DollarSign, Eye, EyeOff, Factory, FileCheck, FileText, Gauge, HardHat, HeartHandshake,
  Landmark, Layers,
  ListChecks, Map, Network, RefreshCw, Ruler, Scale, ScanSearch, Search, Server, ShieldCheck,
  ShoppingCart, Sparkles, Stethoscope, Target, Telescope, TrendingUp, UserCog, Users,
  Video, Workflow,
};

export const Icon = ({ name, className, fallback = "Circle" }) => {
  const C = ICONS[name] || ICONS[fallback] || Circle;
  return <C className={className} strokeWidth={1.5} />;
};
